import { ScrollBar } from '@yes.technology/react-toolkit'
import styled, { css } from 'styled-components'

const borderColor = css`
  ${({ theme }) => theme.colors.status?.default ?? '#abbed1'}
`

const activeBackground = css`
  ${({ theme }) => theme.colors.colorSupportLightGrey ?? '#e8f2ff'}
`

export const EditorWrapper = styled.div`
  border: 1px solid ${borderColor};
  border-radius: 4px;
  overflow: hidden;
`

export const Toolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 8px;
  border-bottom: 1px solid ${borderColor};
  background: ${({ theme }) => theme.colors.white ?? '#f8f9fa'};
`

export const ToolbarGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;

  &:not(:last-child) {
    padding-right: 8px;
    margin-right: 4px;
    border-right: 1px solid ${borderColor};
  }
`

export const ToolbarButton = styled.button<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  padding: 0 6px;
  border: 1px solid
    ${({ $active, theme }) =>
      $active
        ? (theme.colors.primary ?? '#006bff')
        : (theme.colors.status?.default ?? '#abbed1')};
  border-radius: 4px;
  background: ${({ $active, theme }) =>
    $active
      ? (theme.colors.colorSupportLightGrey ?? '#e8f2ff')
      : (theme.colors.white ?? '#fff')};
  color: ${({ theme }) => theme.colors.blackText ?? '#212529'};
  font-size: 13px;
  cursor: pointer;

  &:hover {
    background: ${activeBackground};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const ColorInput = styled.input`
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1px solid ${borderColor};
  border-radius: 4px;
  cursor: pointer;
`

export const LinkInputGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
  width: 100%;
  padding-top: 4px;

  form {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    align-items: center;
    width: 100%;
  }
`

export const LinkUrlInput = styled.input`
  flex: 1;
  min-width: 160px;
  height: 28px;
  padding: 0 8px;
  border: 1px solid ${borderColor};
  border-radius: 4px;
  font-size: 13px;
`

export const EditorScrollBar = styled(ScrollBar)`
  min-height: 176px;
  max-height: 300px;
  padding: 12px;
`

export const EditorContentArea = styled.div`
  .tiptap {
    outline: none;
    min-height: 176px;

    p {
      margin: 0 0 0.5em;
    }

    ul,
    ol {
      padding-left: 1.5em;
    }
  }
`
